<template>
  <div>
    <v-row v-if="evacuationLevel">
      <v-col>
        <div :class="evacClass">
          <span class="level-header-text">Evacuation Level: </span>
          <span class="level-text">{{ evacuationLevel }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";

import { getEvacuationLevelsConfig } from "@/services/controlRisks/risks.service";

export default {
  name: "RisksEvacuationLevel",
  components: {},
  props: {
    background: {
      type: Object,
      required: true,
    },
    evacClass: {
      type: String,
      default: "details-heading application-heading",
    },
  },
  data() {
    return {
      evacuationLevels: [],
    };
  },
  async mounted() {
    this.evacuationLevels = await getEvacuationLevelsConfig({ ui: true }, true);
  },
  computed: {
    evacuationLevel() {
      if (lodashGet(this.background, "properties.formatted.evacuationLevel")) {
        const level = lodashFind(this.evacuationLevels, [
          "level",
          this.background.properties.formatted.evacuationLevel,
        ]);
        if (level && level.name) {
          return level.name;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.level-text {
  text-transform: uppercase;
}
.hyp-risk-evacuation-level .level-header-text {
  font-weight: bold;
}
</style>
